import images from "./images";

const wines = [
  {
    title: "Pakistani chicken dum biriyani",
    price: "৳ 300",
    tags: "BD | Plate",
  },
  {
    title: "Khichuri",
    price: "৳ 180",
    tags: "BD | Plate",
  },
  {
    title: "Lunch platter",
    price: "৳ 320",
    tags: "BD | Plate",
  },
  {
    title: "Bhorta Life",
    price: "৳ 280",
    tags: "BD | Plate",
  },
  {
    title: "Chicken Biriyani",
    price: "৳ 220",
    tags: "BD | Plate",
  },
];

const cocktails = [
  {
    title: "Fruit Custard",
    price: "৳ 200",
    tags: "BD | Box",
  },
  {
    title: "Chocolate lava cake",
    price: "৳ 250",
    tags: "BD | 1 Pound",
  },
  {
    title: "Taler Pudding",
    price: "৳ 260",
    tags: "BD | Box",
  },
  {
    title: "Semolina cupcakes",
    price: "৳ 240",
    tags: "BD | 8 Pieces",
  },
  {
    title: "Shahi Tukda",
    price: "৳ 320",
    tags: "BD | Box",
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: "Best in Rauzan",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
  {
    imgUrl: images.award01,
    title: "Rising Star",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
  {
    imgUrl: images.award05,
    title: "Super Tasty Food",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
  {
    imgUrl: images.award03,
    title: "Outstanding Chef",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
];

export default { wines, cocktails, awards };
